export default __webpack_public_path__ + "static/media/logo_filled_rappi_mustache.a8554e03.svg";